"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const PropType_1 = require("../Types/PropType");
const TypeGuard_1 = require("../Types/TypeGuard");
/**
 * PropTypeGuard provides logic to detect if a property is the correct type.
 */
class PropTypeGuard {
    static isOfType(value, types) {
        return types.some((type) => {
            switch (type) {
                case 'string':
                    return TypeGuard_1.default.isString(value);
                case 'number':
                    return TypeGuard_1.default.isNumber(value);
                case 'boolean':
                    return TypeGuard_1.default.isBoolean(value);
                case 'object':
                    return TypeGuard_1.default.isObject(value);
                case 'array':
                    return TypeGuard_1.default.isArray(value);
                case null:
                    return TypeGuard_1.default.isNull(value);
                default:
                    throw new Error(`Unsupported type used, only these types are supported ${JSON.stringify(PropType_1.propTypes)}`);
            }
        });
    }
}
exports.default = PropTypeGuard;
//# sourceMappingURL=PropTypeGuard.js.map